import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const cardPreviewStyles = {
  emptyContainer: {
    width: '100%',
    minWidth: theme.sizes.paymentCard.minWidth,
    minHeight: theme.sizes.paymentCard.minHeight,
    boxSizing: 'border-box',
    padding: theme.spacing.medium,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    gap: theme.spacing.tiny,
    background: 'linear-gradient(261.57deg, #DEDEDE 2.2%, #B5B5B5 88.3%)',
    borderRadius: theme.radius.md,
  } as CSSProperties,

  emptyExpiry: {
    color: theme.colors.palette.grey800,
    fontFamily: theme.typography.cardFontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: 15,
    lineHeight: '24px',
    letterSpacing: 0,
  } as CSSProperties,

  emptyCardNumber: {
    color: theme.colors.palette.grey800,
    fontFamily: theme.typography.cardFontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: 15,
    lineHeight: '24px',
    letterSpacing: 0,
  } as CSSProperties,

  emptyHolderName: {
    color: theme.colors.palette.neutralPressed,
    fontFamily: theme.typography.cardFontFamily,
    fontWeight: theme.typography.fontWeight.normal,
    fontSize: 15,
    lineHeight: '30px',
    textTransform: 'uppercase',
    letterSpacing: 0,
  } as CSSProperties,
};
